import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { environment } from "src/environments/environment";
import { RedirectComponent } from "./features/home/redirect/redirect.component";
import { AuthGuard } from "./helpers/auth.guard";
import { TrialLandingGuard } from "./helpers/trial-landing.guard";
import { EvaLayoutComponent } from "./layout/eva-layout/eva-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { PublicLayoutComponent } from "./layouts/public-layout/public-layout.component";

const routes: Routes = [
  // Design System - exclu en production (showcase uniquement)
  ...(environment.production
    ? []
    : [
        {
          path: "design-system",
          loadChildren: () => import("./features/design-system/design-system.module").then((m) => m.DesignSystemModule),
        },
      ]),
  {
    path: "",
    pathMatch: "full",
    component: RedirectComponent,
    canActivate: [TrialLandingGuard],
    runGuardsAndResolvers: "always",
  },
  {
    path: "",
    component: EvaLayoutComponent,
    children: [
      {
        path: "home",
        loadChildren: () => import("src/app/features/home/home.module").then((m) => m.HomeModule),
        canActivate: [AuthGuard],
      },
      {
        path: "",
        loadChildren: () => import("./layout/eva-layout.module").then((m) => m.EvaLayoutModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/project/project.module").then((m) => m.ProjectModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/invoice/invoice.module").then((m) => m.InvoiceModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/features/working-activity/working-activity.module").then((m) => m.WorkingActivityModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/customer/customer.module").then((m) => m.CustomerModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/event/event.module").then((m) => m.EventModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/planning/planning.module").then((m) => m.PlanningModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/features/purchase-order/purchase-order.module").then((m) => m.PurchaseOrderModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/supplier/supplier.module").then((m) => m.SupplierModule),
      },
      { path: "workshops", redirectTo: "/settings?section=workshops", pathMatch: "full" },
      { path: "workshops/settings", redirectTo: "/settings?section=numbering", pathMatch: "full" },
      { path: "workshop/:id", redirectTo: "/settings?section=workshops", pathMatch: "full" },
      {
        path: "",
        loadChildren: () => import("src/app/features/eva-company/eva-company.module").then((m) => m.EvaCompanyModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/banking/banking.module").then((m) => m.BankingModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/features/interventions/interventions.module").then((m) => m.InterventionsModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/employees/employees.module").then((m) => m.EmployeesModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/hr-space/hr-space.module").then((m) => m.HrSpaceModule),
      },
      // Route user-profile supprimée : profil migré dans settings-container (?section=profile)
      {
        path: "",
        loadChildren: () => import("src/app/features/accounting/accounting.routes").then((m) => m.ACCOUNTING_ROUTES),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/contact/contact.module").then((m) => m.ContactModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/features/expense-report/expense-report.module").then((m) => m.ExpenseReportModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/offer-v2/offer-v2.module").then((m) => m.OfferV2Module),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/catalog/catalog.module").then((m) => m.CatalogModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/eva-task/eva-task.module").then((m) => m.EvaTaskModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/ai-chat/ai-chat.module").then((m) => m.AiChatModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/task/task.module").then((m) => m.TaskModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/features/import-issued-invoice/import-issued-invoice.module").then(
            (m) => m.ImportIssuedInvoiceModule,
          ),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/scan-emails/scan-emails.module").then((m) => m.ScanEmailsModule),
      },
      {
        path: "",
        loadChildren: () =>
          import("src/app/features/subscription/eva-subscription.module").then((m) => m.EvaSubscriptionModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/settings/settings.module").then((m) => m.SettingsModule),
      },
      {
        path: "",
        loadChildren: () => import("src/app/features/pairing/pairing.module").then((m) => m.PairingModule),
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () => import("./layouts/auth-layout/auth-layout.module").then((m) => m.AuthLayoutModule),
      },
    ],
  },
  {
    path: "redirect",
    component: RedirectComponent,
  },
  {
    path: "",
    component: PublicLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () => import("./layouts/public-layout/public-layout.module").then((m) => m.PublicLayoutModule),
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [],
})
export class AppRoutingModule {}
